<template>
  <div class="vx-row justify-content-center mt-2 mb-2">
    
    <div class="vx-col w-1/3">
      <!-- Added class 'rotate-canvas-wrapper' here -->
      <div class="vx-row justify-content-center rotate-canvas-wrapper">
        <vue-circle
          :progress="relevancy"
          :size="80"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center mt-2">
          <span class="font-bold">{{ $t("components.progressMeasureChart.pmc1") }}</span>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <!-- Added class 'rotate-canvas-wrapper' here -->
      <div class="vx-row justify-content-center rotate-canvas-wrapper">
        <vue-circle
          :progress="progress"
          :size="80"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center mt-2">
          <span class="font-bold">{{ $t("components.progressMeasureChart.pmc2") }}</span>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <!-- Added class 'rotate-canvas-wrapper' here -->
      <div class="vx-row justify-content-center rotate-canvas-wrapper">
        <vue-circle
          :progress="practice"
          :size="80"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center mt-2">
          <span class="font-bold">{{ $t("components.progressMeasureChart.pmc3") }}</span>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import VueCircle from 'vue2-circle-progress/src/index.vue'

  export default {
    name: "ProgressMeasureChart",
    props: ["progress", "practice", "relevancy"],
    components: {
      VueCircle
    },
    methods: {
      progress_circle(event,progress,stepValue){
        console.log(stepValue);
      },
      progress_end_circle(event){
        console.log("Circle progress end");
      }
    },
    data() {
      return {
        fill: {gradient: ["#079E9A", "#76C488", "#9DCD5B"]},
        rel: [this.relevancy],
        prog: [this.progress],
        prac: [this.practice],
      }
    }
  };
</script>

<style scoped>
  .justify-content-center{
    justify-content: center;
  }
</style>

<!-- This global style forces ONLY the canvas to rotate to 12 o'clock. The text stays upright! -->
<style>
  .rotate-canvas-wrapper canvas {
    transform: rotate(-90deg) !important;
    display: block !important;
  }
</style>